module.exports = __webpack_public_path__ + "static/icon_milano_sudest_nero-538f6cd22016fcf40903229d72c50bee.svg";